import React, { useMemo, useRef } from "react";
import { useStripe, useElements, CardElement } from "@stripe/react-stripe-js";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import MediaCard from "./selectedCard";

// import useResponsiveFontSize from "./useResponsiveFontSize";

const useOptions = () => {
  // const fontSize = useResponsiveFontSize();
  const options = useMemo(
    () => ({
      style: {
        base: {
          fontSize: "1.5rem",
          color: "#424770",
          letterSpacing: "0.025em",
          fontFamily: "Source Sans Pro, sans serif, Source Code Pro, monospace",
          "::placeholder": {
            color: "#aab7c4",
          },
        },
        invalid: {
          color: "#9e2146",
        },
      },
    }),
    []
  );

  return options;
};

const CardForm = (props) => {
  var promoCode = "";
  const stripe = useStripe();
  const elements = useElements();
  const options = useOptions();
  const handleFormChange = (data) => {
    props.handleFormChange(data);
  };

  const promoCodesWithoutPaymentMethods = ["REFER", "TASKREFER", "INPATIENT", "LOCALCLINIC", "REMOTECLINIC", "INSURANCE"];

  const handleSubmit = async (event) => {
    event.preventDefault();
    console.log(promoCode.value)
    if(!promoCodesWithoutPaymentMethods.includes(promoCode.value) && (!stripe || !elements)){
        return;
    }
    
    let paymentMethodPayload = {}; 
    if(!promoCodesWithoutPaymentMethods.includes(promoCode.value)){
      paymentMethodPayload = await stripe.createPaymentMethod({
        type: "card",
        card: elements.getElement(CardElement),
      });;
    }

    paymentMethodPayload.promoCode = promoCode.value;
    console.log("Payment method created:", paymentMethodPayload);
    if (paymentMethodPayload.error) {
      console.log(`There was an error creating the payment method: ${paymentMethodPayload.error}`);
    } else {
      props.handleFormChange("protection");
      props.onSubmit(paymentMethodPayload);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={3} alignItems="center">
        <Grid item container xs={12} justify="center">
          <MediaCard
            peripheralType={props.deviceSelection.data.peripheral_type}
            telehealth={props.deviceSelection.data.telehealth}
            handleFormChange={props.handleFormChange}
            handleDeviceSelect={props.handleDeviceSelect}
          />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h5">Card details</Typography>
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 40, paddingBottom: 40 }}>
          <CardElement options={options} />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h5">Promo Code</Typography>
        </Grid>
        <Grid item xs={12}>
        <TextField
          fullWidth
          id="promo-code"
          name="promo_code"
          label="Promo Code"
          variant="outlined"
          inputRef={el => {
            promoCode = el;
          }}
        />
      </Grid>
        <Grid item xs={6}>
          <Button
            style={{ background: "#666666" }}
            id="return"
            type="back"
            name="back"
            label="Back"
            size="large"
            variant="contained"
            color="secondary"
            disableElevation
            fullWidth
            onClick={() => {
              handleFormChange("customer");
            }}
          >
            Back
          </Button>
        </Grid>
        <Grid item xs={6}>
          <Button
            style={{ background: "#464d7c" }}
            disabled={!stripe}
            id="submit"
            type="submit"
            name="submit"
            label="Submit"
            size="large"
            variant="contained"
            color="primary"
            disableElevation
            fullWidth
          >
            Next
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default CardForm;
